import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'antd';
import { DatabaseOutlined } from '@ant-design/icons';
import shared from '../../shared.scss';
import style from './index.scss';

// Custom Tables tab (Spatial) — config-driven tables built from the alert's
// custom groups/fields. Each entry renders as a titled section with a category
// tag and its own table. The live config lands with FIN-11586; until then this
// runs on the mock fixture (alertDetailMock.customTables).
//
// Fixture shape:
//   { name: string, tag: string, columns: string[], rows: string[][] }
// Rows are positional arrays, so columns/cells are keyed by index.

const toColumns = (labels = []) =>
  labels.map((label, i) => ({
    title: label,
    dataIndex: String(i),
    key: String(i)
  }));

const toRows = (rows = []) =>
  rows.map((cells, r) => {
    const row = { key: String(r) };
    (cells || []).forEach((cell, i) => {
      row[String(i)] = cell;
    });
    return row;
  });

const CustomTablesPanel = ({ tables }) => {
  if (!tables || !tables.length) {
    return (
      <div className={style.customTablesWrap}>
        <div className={style.ctEmpty}>
          <DatabaseOutlined />
          No custom tables configured for this alert
        </div>
      </div>
    );
  }

  return (
    <div className={style.customTablesWrap}>
      {tables.map((t) => (
        <section key={t.name}>
          <div className={style.ctHead}>
            <span className={style.ctName}>{t.name}</span>
            {t.tag ? (
              <span className={`${shared.statusBadge} ${shared.badgeGray}`}>
                {t.tag}
              </span>
            ) : null}
          </div>
          <div className={shared.dataTable}>
            <Table
              size="middle"
              columns={toColumns(t.columns)}
              dataSource={toRows(t.rows)}
              pagination={false}
            />
          </div>
        </section>
      ))}
    </div>
  );
};

CustomTablesPanel.propTypes = {
  tables: PropTypes.array
};

export default CustomTablesPanel;
